import type { ContentNugget } from '@backrs_ui/common-ui';

import type { AgentContextNugget } from './types';

export const toAgentContextNugget = (nugget: ContentNugget): AgentContextNugget => ({
  id: nugget.id,
  variant: nugget.variant,
  title: nugget.title,
  description: nugget.description,
  format: nugget.format ?? null,
  theme: nugget.content_nugget_theme ?? null,
});
